import {
    PAYMENT_PXPAY_REQUEST,
    PAYMENT_PXPAY_SUCCESS,
    PAYMENT_PXPAY_FAILURE,
    WINDCAVE_PROCESS_PAYMENT_REQUEST,
    WINDCAVE_PROCESS_PAYMENT_SUCCESS,
    WINDCAVE_PROCESS_PAYMENT_FAILURE,
    UPDATE_TOKEN_PAYMENT_REQUEST,
    UPDATE_TOKEN_PAYMENT_SUCCESS,
    UPDATE_TOKEN_PAYMENT_FAILURE,
    PAYMENT_TYPES_SUCCESS,
} from './../../constants';

const initialPxPayState = {
    loader: false,
    success: false,
    failed: false,
    payment: null,
    statusRedirectUrl: null,
    productMessage: true,
    cardOptions: [],
};
  
export default (state = initialPxPayState, action) => {
  
    //This is to ensure immutability of state
    const newState = {...state};
  
    switch (action.type) {
    case PAYMENT_PXPAY_REQUEST:
    case WINDCAVE_PROCESS_PAYMENT_REQUEST:
    case UPDATE_TOKEN_PAYMENT_REQUEST:
        newState.loader = true;
        newState.failed = false;
        newState.success = false;
        newState.payment = null;
        return newState;
    case PAYMENT_PXPAY_SUCCESS:
    case UPDATE_TOKEN_PAYMENT_SUCCESS:
        if (action.data && action.data.redirectUrl !== 'undefined' && 
            action.data.redirectUrl !== undefined){
            newState.successRedirectUrl = action.data.successRedirectUrl;
            newState.produceMessage = action.data.produceMessage;
            window.location.assign(action.data.redirectUrl);
            newState.success = true;
            newState.failed = false;
        } else {
            newState.success = false;
            newState.failed = true;
        }
        newState.loader = false;    
        return newState;
    case PAYMENT_TYPES_SUCCESS:
        newState.cardOptions = action.data.paymentTypes;
        return newState;
    case PAYMENT_PXPAY_FAILURE:
    case WINDCAVE_PROCESS_PAYMENT_FAILURE:
    case UPDATE_TOKEN_PAYMENT_FAILURE:
        newState.loader = false;
        newState.failed = true;
        newState.success = false;
        newState.payment = null;
        return newState;
    case WINDCAVE_PROCESS_PAYMENT_SUCCESS:
        if (action.data?.success_redirect_url?.length > 0){
            window.location.assign(`${action.data.success_redirect_url}?payment_details_updated=${action.data.result}`);
        } else {
            window.location.assign('/payment_pxpay_status');
        }
        newState.payment = action.data;   
        newState.loader = false;    
        newState.success = true;
        newState.failed = false;
        return newState;
    default:
        return state;
    }
};
  